/** @format */

import React, { useEffect, useReducer, useCallback, useRef } from "react";
import { emailOrganization } from "../../../../API/endpoints";
import { Button, Modal, Form } from "react-bootstrap";
import { connect } from "react-redux";
import { toast } from "react-toastify";
import {
  successOutreachEmail,
  failureOutreachEmail,
} from "../../../../tools/toasters";
import DOMPurify from "dompurify";

/**
 * @param {function} onHide
 * @param {function} postActivity
 * @param {object} modal
 * @param {boolean} show
 *
 * This component returns the modal that the user interfaces with when trying to report an organization. The issue will be send to the Compliance inbox for further examination
 */

const initialState = {
  requestingUserName: "",
  requestingUserId: "",
  requestingCompany: "",
  requestingCompanyId: "",
  requestingUserEmail: "",
  selectedOrganization: "",
  selectedOrganizationLocation: "",
  selectedOrganizationEmail: "",
  selectedOrganizationCategories: [],
  selectedOrganizationInteractionType: [],
  emailTitle: "",
  emailBody: "",
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case "MERGE_GLOBAL_DETAILS":
      return {
        ...state,
        requestingUserName: action.payload.userName,
        requestingUserId: action.payload.userId,
        requestingCompany: action.payload.company,
        requestingCompanyId: action.payload.companyId,
        requestingUserEmail: action.payload.userEmail,
        selectedOrganization: action.payload.selectedOrganization,
        selectedOrganizationLocation:
          action.payload.selectedOrganizationLocation,
        selectedOrganizationEmail: action.payload.selectedOrganizationEmail,
        selectedOrganizationCategories:
          action.payload.selectedOrganizationCategories,
        selectedOrganizationInteractionType:
          action.payload.selectedOrganizationInteractionType,
      };
    case "FLUSH_GLOBAL_DATA":
      return { ...state, emailTitle: "", emailBody: "" };
    case "HANDLE_CHANGE_INPUT":
      return { ...state, ...action.payload };
    case "HANDLE_CHANGE_SELECT":
      return { ...state, ...action.payload };
    default:
      return state;
  }
};

export const EmailOrganizationModal = ({ user, show, onHide, row }) => {
  const formRef = useRef();

  const [state, dispatch] = useReducer(reducer, initialState);
  //   const { additionalInformation } = state;

  useEffect(() => {
    dispatch({
      type: "MERGE_GLOBAL_DETAILS",
      payload: {
        userName: user.user.firstName + " " + user.user.lastName,
        userId: user.user.user_id,
        userEmail: user.user.email,
        company: user.user.company.companyName,
        companyId: user.user.company.companyId,
        selectedOrganization: row.site_name,
        selectedOrganizationLocation: `${row.City}, ${row.State}`,
        selectedOrganizationEmail: row.contact,
        selectedOrganizationCategories: row.ans,
        selectedOrganizationInteractionType: ["Email"],
      },
    });
  }, [user, row]);

  const handleSubmit = useCallback(
    async (e) => {
      e.preventDefault();
      formRef.current.classList.add("was-validated");
      if (formRef.current.checkValidity()) {
        const data = await emailOrganization(state, user.user.jtToken);

        if (data.status === 200) {
          toast(successOutreachEmail, {
            position: toast.POSITION.TOP_CENTER,
          });
        } else {
          toast.error(failureOutreachEmail);
        }
        onHide();
        setTimeout(function () {
          dispatch({ type: "FLUSH_GLOBAL_DATA" });
        }, 1000);
      }
    },
    [state, onHide, user]
  );
  return (
    <Modal
      show={show}
      onHide={onHide}
      size="md"
      aria-labelledby="contained-modal-title-vcenter"
      centered={true}
    >
      <Modal.Header className="bg-white">
        <Modal.Title id="contained-modal-title-vcenter">
          Email Organization
        </Modal.Title>
      </Modal.Header>

      <Form ref={formRef} noValidate onSubmit={(e) => handleSubmit(e)}>
        <Modal.Body>
          <Form.Group className="mb-3">
            <Form.Label>
              User Email <span className="text-danger">*</span>
            </Form.Label>
            <Form.Control
              readOnly
              required
              value={user.user.email}
            ></Form.Control>
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label>
              Organization Name <span className="text-danger">*</span>
            </Form.Label>
            <Form.Control
              readOnly
              required
              value={state.selectedOrganization}
            ></Form.Control>
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label>
              Organization Email <span className="text-danger">*</span>
            </Form.Label>
            <Form.Control
              readOnly
              required
              value={state.selectedOrganizationEmail}
            ></Form.Control>
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label>Email Title</Form.Label>
            <Form.Control
              value={state.emailTitle}
              name="emailTitle"
              required
              rows={4}
              onChange={(e) => {
                const purify = DOMPurify.sanitize(e.target.value);
                dispatch({
                  type: "HANDLE_CHANGE_INPUT",
                  payload: { [e.target.name]: purify },
                });
              }}
            />
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label>Email Body</Form.Label>
            <Form.Control
              value={state.emailBody}
              name="emailBody"
              as="textarea"
              required
              rows={4}
              onChange={(e) => {
                const purify = DOMPurify.sanitize(e.target.value);
                dispatch({
                  type: "HANDLE_CHANGE_INPUT",
                  payload: { [e.target.name]: purify },
                });
              }}
            />
          </Form.Group>
        </Modal.Body>
        <Modal.Footer>
          <Button
            className="btn"
            style={{
              backgroundColor: "white",
              color: "#599EE4",
              border: "none",
            }}
            type="button"
            onClick={onHide}
          >
            Cancel
          </Button>
          <Button type="submit" className="submit__button">
            Submit
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
};

const mapStateToProps = (state) => ({
  user: state.user,
  inventory: state.inventory.inventoryData,
});

export default connect(mapStateToProps)(EmailOrganizationModal);
